import axios from 'axios';

const axiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_API_BASE_URL ||
    'https://dev-apiefficax-zaeroon.ascend.com.sa',
  timeout: 10000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.status, error.response?.data);

    if (error.response && error.response.status === 401) {
      console.warn('Unauthorized! Logging out...');
      localStorage.removeItem('token'); // Clear Token
      window.location.href = '/'; // Redirect to Login Page
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
